// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__j4w6M","box":"style_box__tZ8jz","active":"style_active__oT1rd","title":"style_title__5v7w+","item":"style_item__CKLe9"};